import {
  ConfigurableProduct
} from "@/types/graphql.prod";
import {
  gql,
  useMutation
} from "@apollo/client";
import {
  useMemo
} from "react";

export const ADD_PRODUCT_TIP = gql`
    mutation addProductTip($product_id: Int!, $sku: String!, $email: String!) {
        addProductTip(
            input: { product_id: $product_id, sku: $sku, email: $email }
        ) {
            code
            message
            content
        }
    }
`;
export const useAddProductTip = ({
  product 
}:{
  product: ConfigurableProduct;
}) => {

  const {
    id: productId 
  } = product || {}

  const [addProductTip, {
    data, error, loading: isLoading
  }] = useMutation(
    ADD_PRODUCT_TIP,
    {
      fetchPolicy: "no-cache",
    }
  )

  const handleSubmit = async ({
    email,
    selectedProduct
  }:{
    email: string;
    selectedProduct: any;
  }) => {
    if (!selectedProduct) {
      return
    }

    try {
      await addProductTip({
        variables: {
          product_id: productId || selectedProduct?.product?.id,
          sku: selectedProduct?.product?.sku,
          email,
        },
      })

    } catch (error) {
      if (process.env.NODE_ENV !== "production") {
        console.error(error)
      }
    } finally {
    }
  }

  const errors = useMemo(
    () => new Map([["addProductTipError", error]]),
    [error]
  )

  return {
    formErrors: errors,
    isLoading,
    handleSubmit,
    response: data && data.addProductTip,
  }
}
